import SurveyEvaluationScaleLoader from '../Loaders/SurveyEvaluationScaleLoader';
import EvaluationScaleForm from './EvaluationScaleForm';

function EvaluationScaleEdit() {
  return (
    <SurveyEvaluationScaleLoader>
      <EvaluationScaleForm />
    </SurveyEvaluationScaleLoader>
  );
}

export default EvaluationScaleEdit;
